import registerExternalLinksInterrupter from './external-links';

export default {
  registerExternalLinksInterrupter,
};
